let storageURL: string

if (import.meta.env.VITE_IS_LIBRARY_MODE) {
  storageURL = 'https://storage.googleapis.com/trillionprod.appspot.com'
} else {
  storageURL = 'https://storage.googleapis.com/ameappdebug.appspot.com'
}

function getBaseUrl() {
  return `${storageURL}/Resources/Web`
}

export function setStorageBaseUrl(url: string) {
    storageURL = url
}

export function getJewelryPath(jewelryId: string): string {
  return `${getBaseUrl()}/${jewelryId}.gltf`
}

export function getResourcePath(fileName: string): string {
  return `${getBaseUrl()}/${fileName}`
}

export function getMLModelUrl(name: string): string {
  return `${getBaseUrl()}/MLModels/${name}/model.json`
}
